import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class SubstanceScreeningResult extends AbstractModel {
  @autoserialize
  transmissionId: string;

  @autoserialize
  dilute: boolean;

  @autoserialize
  chainOfCustodyIdentifier: string;

  @autoserialize
  result: string;

  @autoserializeAs(Date)
  labReceivedDate: Date;

  @autoserializeAs(Date)
  labReportedDate: Date;

  @autoserializeAs(Date)
  collectedDate: Date;

  @autoserializeAs(Date)
  verifiedDate: Date;

  /**** Serialization ****/

  public static OnSerialized(instance: SubstanceScreeningResult, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.labReceivedDate)) {
      json.labReceivedDate = DateUtil.serializeDate(instance.labReceivedDate);
    }
    if (!isNullOrUndefined(instance.labReportedDate)) {
      json.labReportedDate = DateUtil.serializeDate(instance.labReportedDate);
    }
    if (!isNullOrUndefined(instance.collectedDate)) {
      json.collectedDate = DateUtil.serializeDate(instance.collectedDate);
    }
    if (!isNullOrUndefined(instance.verifiedDate)) {
      json.verifiedDate = DateUtil.serializeDate(instance.verifiedDate);
    }
  }

  public static OnDeserialized(instance: SubstanceScreeningResult, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['labReceivedDate'])) {
      instance.labReceivedDate = DateUtil.deserializeDate(json['labReceivedDate']);
    }
    if (!isNullOrUndefined(json['labReportedDate'])) {
      instance.labReportedDate = DateUtil.deserializeDate(json['labReportedDate']);
    }
    if (!isNullOrUndefined(json['collectedDate'])) {
      instance.collectedDate = DateUtil.deserializeDate(json['collectedDate']);
    }
    if (!isNullOrUndefined(json['verifiedDate'])) {
      instance.verifiedDate = DateUtil.deserializeDate(json['verifiedDate']);
    }
  }
}
